<template>
    <div>
        <div v-if="isMultiple == false" class="with-absolute-button" id="multi-select-white">
            <multi-select  class="light-bg" v-model="localSelectedStructureUser" label="name" track-by="id"
                open-direction="bottom" :options="structureUsers" :searchable="true" :loading="loading"
                :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                :max-height="600" :show-no-results="false" :hide-selected="true" :multiple="false"
                @search-change="getStructureUsers" @select="structureUserSelectChanged" @close="structureUsers = []"
                :allow-empty="false" ref="multiselect1" :disabled="disabled" :placeholder="$t('res_Label_SelectOption')">
                <template slot="option" slot-scope="props">
                    <div style="height: 50px; width: 100%; display: flex;text-align:start">
                        <div class="" style="">
                            <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                        </div>
                        <div class="ad__box" v-if="props.option.isUser">
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                        <div class="ad__box" v-else>
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                    </div> 
                </template>
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
            <button :disabled="disabled" @click="openAddressBook">
                <v-icon class="float-right">mdi-user-add</v-icon>
            </button>
        </div>

        <div id="multi-select-white" v-else class="with-absolute-button">
            <multi-select  id="multi-select-white" class="light-bg" v-model="localselectedStructureUsersList" label="name" track-by="id"
                :class="{ 'is--active': localselectedStructureUsersList.length > 1 }" open-direction="bottom"
                :options="structureUsers" :searchable="true" :loading="loading" :internal-search="false"
                :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                :show-no-results="false" :hide-selected="true" :multiple="true" @search-change="getStructureUsers"
                @input="structureUserSelectMultipleChanged" @close="structureUsers = []" :allow-empty="false"
                ref="multiselect1" :disabled="disabled" :placeholder="$t('res_Label_SelectOption')">
                <template slot="option" slot-scope="props">
                    <div style="width: 100%; display: flex;text-align:start; ">
                        <div class="" style="">
                            <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                        </div>
                        <div class="ad__box" v-if="props.option.isUser">
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                        <div class="ad__box" v-else>
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                    </div>
                </template>
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
            <button :disabled="disabled" @click="openAddressBook">
                <v-icon>mdi-user-add</v-icon>
            </button>
        </div>

        <v-dialog v-model="addressBookDialog" content-class="dialog2 address-book-dialog with-fixed-actions">
            <div class="dialog-header" style="z-index: 3000 !important;">
                <h1 v-if="addressBook_header == ''">{{ $t('res_Label_Strucutres') }}</h1>
                <h1 v-else>{{ addressBook_header }}</h1>
            </div>
            <div class="dialog-body white-container">
                <address-book :showExternalUsers="showExternalUsers" :showInternalUsers="showInternalUsers" :showAllInternal="showAllInternal"
                    :singleValue="addressBookDialog_Single" :reset="addressBookDialog_reset"
                    :showInternalStructures="addressBook_showInternalStructures" :ignorePermissions="ignorePermissions"
                    :showExternalStructures="addressBook_showExternalStructures" :defaultValue="addressBookDialog_ListValue"
                    :disableOtherInternalEntitiesAsExternal="disableOtherInternalEntitiesAsExternal"
                    @closeAddressBook="closeAddressBook" @handleSelectFromAddressBook="handleSelectFromAddressBook"
                    :allowedUsersRoles="allowedUsersRoles" :allowStructureSelect="addressBookDialog_allowStructureSelect"
                    :isForSignee="isForSignee" :excludeSelf="excludeSelf" :hideStructureWithDisableTransfer="hideStructureWithDisableTransfer"
                    :loadOnlyInScopeInternalStrucutres="loadOnlyInScopeInternalStrucutres" :loadOnlyInScopeInternalUsers="loadOnlyInScopeInternalUsers" :calledFromField="calledFromField"
                    :sortInternalFirst="sortInternalFirst"></address-book>
            </div>
        </v-dialog>
    </div>
</template>

<script>
import constants from '@/assets/js/constants.js'
import MultiSelect from 'vue-multiselect'
import axios from 'axios';
import * as utils from '@/assets/js/common.js'
import AddressBook from '@/components/AddressBook.vue'

export default {
    name: 'StructureUserSelector',
    components: { MultiSelect, AddressBook },
    props: {
        showInternalUsers: { type: Boolean, default: false },
        showExternalUsers: { type: Boolean, default: false },
        showInternalStructures: { type: Boolean, default: false },
        showExternalStructures: { type: Boolean, default: false },
        disableOtherInternalEntitiesAsExternal: { type: Boolean, default: false },
        isMultiple: { type: Boolean, default: false },
        selectedStructureUser: null,
        selectedStructureUsersList: null,
        dataToPassOnSelectChange: null,
        allowedUsersRoles: { type: Array, default: () => [] },
        isForSignee: { type: Boolean, default: false },
        excludeSelf: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        addressBook_header: { type: String, default: '' },
        hideStructureWithDisableTransfer: { type: Boolean, default: false },
        loadOnlyInScopeInternalStrucutres: { type: Boolean, default: false },
        loadOnlyInScopeInternalUsers: { type: Boolean, default: false },
        calledFromField:{ type: String, default:"" },
        showAllInternal: { type: Boolean, default: false },
        ignorePermissions: { type: Boolean, default: false },
        sortInternalFirst: { type: Boolean, default: false }
    },
    data() {
        return {
            lang: localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en',
            loading: false,
            structureUsers: [],
            addressBookDialog: false,
            addressBookDialog_Single: true,
            addressBookDialog_Title: '',
            addressBookDialog_ListValue: [],
            addressBookDialog_reset: 1,
            addressBookDialog_allowStructureSelect: false,
            addressBook_showInternalStructures: false,
            addressBook_showExternalStructures: false,
            localSelectedStructureUser: this.selectedStructureUser,
            localselectedStructureUsersList: this.selectedStructureUsersList,
            utils : utils
        }
    },
    mounted() {
        //this.label = utils.GetTranslatedValue('name','nameAr')
    },
    watch:
    {
        selectedStructureUser(newVal) {
            this.localSelectedStructureUser = newVal;
        },
        selectedStructureUsersList(newVal) {
            this.localselectedStructureUsersList = newVal;
        },
    },
    methods: {
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        getStructureUsers(query) {
            if (query == '')
                return
            var calledFromFieldCustom = this.calledFromField;
            // if (constants.client_version_Id == 'DDA' && !this.ignorePermissions){
            //     this.showExternalUsers = true;
            //     this.showExternalStructures = true;
            // }

            this.loading = true
            axios.get(constants.baseApiUrl + 'StructureUser/SearchWithAddressbook?' +
                'showInternalUsers=' + this.showInternalUsers +
                '&showExternalUsers=' + this.showExternalUsers +
                '&showInternalStructures=' + this.showInternalStructures +
                '&showExternalStructures=' + this.showExternalStructures +
                '&excludeSelf=' + this.excludeSelf +
                '&allowedUsersRoles=' + (this.allowedUsersRoles && this.allowedUsersRoles.length > 0 ? this.allowedUsersRoles : "") +
                '&isForSignee=' + this.isForSignee +
                '&calledFromField=' + this.calledFromField +
                '&disableOtherInternalEntitiesAsExternal=' + this.disableOtherInternalEntitiesAsExternal +
                '&hideStructureWithDisableTransfer=' + this.hideStructureWithDisableTransfer +
                '&loadOnlyInScopeInternalStrucutres=' + this.loadOnlyInScopeInternalStrucutres +
                '&loadOnlyInScopeInternalUsers=' + this.loadOnlyInScopeInternalUsers +
                '&ignorePermissions=' + this.ignorePermissions +
                '&search=' + query)
                .then((res) => {
                    var data = res.data
                    if (this.sortInternalFirst && Array.isArray(data)) {
                        data = data.slice().sort((a, b) => (a.isExternal ? 1 : 0) - (b.isExternal ? 1 : 0))
                    }
                    this.structureUsers = data
                })
                .catch((err) => console.warn(err))
                .finally(() => this.loading = false)
        },
        structureUserSelectChanged(item) {
            this.$set(this, 'localSelectedStructureUser', item);
            this.$emit('structureUserSelectChanged', item, this.dataToPassOnSelectChange);
            this.structureUsers = [];
        },
        structureUserSelectMultipleChanged(selectedItems) {
            this.$set(this, 'localselectedStructureUsersList', selectedItems);
            this.$emit('structureUserSelectChanged', selectedItems);

            this.structureUsers = [];
        },

        openAddressBook() {
            this.addressBookDialog_Single = !this.isMultiple;
            this.addressBookDialog_ListValue = [];

            this.addressBook_showInternalStructures = this.showInternalStructures || this.showInternalUsers;
            this.addressBook_showExternalStructures = this.showExternalStructures || this.showExternalUsers;

            if (this.showInternalStructures || this.showExternalStructures) {
                this.addressBookDialog_allowStructureSelect = true;
            } else {
                this.addressBookDialog_allowStructureSelect = false;
            }

            if (this.isMultiple) {
                for (var i = 0; i < this.structureUsers.length; i++) {
                    if (this.structureUsers[i].id != null) {
                        valuesList.push({
                            id: this.structureUsers[i].id,
                            name: this.structureUsers[i].name,
                            isUser: this.structureUsers[i].isUser
                        })
                    }
                }
            } else {

            }

            this.addressBookDialog_reset = new Date().valueOf();
            this.addressBookDialog = true
        },
        closeAddressBook() {
            this.addressBookDialog = false
        },
        handleSelectFromAddressBook(selectedItems) {
            if (!this.isMultiple) {
                this.structureUserSelectChanged(selectedItems);
            }
            else {
                if (this.selectedStructureUsersList.length > 1) {
                    this.selectedStructureUsersList.forEach((item) => {
                        if (item.id && !selectedItems.some(x => x.id == item.id)) {
                            selectedItems.push(item);
                        }
                    });
                }

                selectedItems.unshift({});

                this.structureUserSelectMultipleChanged(selectedItems);
            }

            this.closeAddressBook()
        }
    }
}
</script>

<style scoped>
#dwt-container {
    display: flex;
    height: inherit;
    width: inherit;
}

#dwt-control {
    max-width: 400px;
}
</style>